import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next";
import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend, AreaChart, Area, Tooltip } from "recharts"


export const StepsHistoryGraph = ({
    stepsData,
    date,
    onDateChange = (e) => { }
}) => {

     const [t] = useTranslation(["global", "health"]);

    // Funzioni per ottenere inizio e fine della giornata
    const getStartOfDay = () => Math.floor(date.setHours(0, 0, 0, 0));
    const getEndOfDay = () => Math.floor(date.setHours(23, 59, 59, 999));

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-dark card">
                    <div className="card-header"><b>{payload[0].value}</b> {t("health:unit.steps")}</div>
                    <div className="card-footer"> {new Date(label * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</div>

                </div>
            );
        }

        return null;
    };


    return <div className="card mt-2 bg-black bg-opacity-10 text-white p-4">

        {/* BPM Massimo e Minimo */}
        <div className="d-flex  justify-content-between mb-3">
            <div>
                <h4><i className="fa-solid fa-shoe-prints text-muted"></i> {t("health:entity.data.steps_daily")}</h4>
                <span className="small text-muted">{stepsData.length} {t("health:unit.measurements", {count:stepsData.length})}</span>
            </div>

            <div>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} dateFormat="dd/mm/yy" />
            </div>

        </div>

        {/* Grafico */}
        {
            stepsData?.length > 0 ?
                <ResponsiveContainer width="100%" height={400}>
                    <AreaChart data={stepsData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" opacity={0.5}/>
                        <XAxis
                            dataKey="timestamp"

                            type="number"
                            domain={[getStartOfDay() / 1000, getEndOfDay() / 1000]}
                            tickFormatter={(tick) =>
                                new Date(tick * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
                            }
                            ticks={[(getStartOfDay()/1000, getStartOfDay() / 1000) + 21600, (+getStartOfDay() / 1000) + 43200, (+getStartOfDay() / 1000) + 64800, getEndOfDay() / 1000]}
                            scale="time"
                        />
                        <YAxis dataKey="steps"
                            type="number"
                        />
                        <Tooltip content={CustomTooltip} />
                        <Legend />
                        <Area type="monotone" dataKey="steps" name={t("health:unit.steps")} fill="orange" stroke="orange" strokeWidth={2}/>
                    </AreaChart>
                </ResponsiveContainer>
                : <h3 className="text-muted">{t("health:helper.no_data")}</h3>
        }
    </div>
}